var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfileCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.541,
    height: 20.688,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.071 4.7A4.238 4.238 0 0 1 11.839.468a.469.469 0 0 0-.47-.47h-6.2a.466.466 0 0 0-.47.47A4.241 4.241 0 0 1 .467 4.7a.466.466 0 0 0-.47.47v3.122A13.479 13.479 0 0 0 8.08 20.644a.5.5 0 0 0 .188.042.546.546 0 0 0 .188-.042 13.467 13.467 0 0 0 8.083-12.352V5.17a.468.468 0 0 0-.47-.47Zm-3.489 3.268-5.407 5.407a.466.466 0 0 1-.668 0l-2.548-2.548a.474.474 0 0 1 0-.668.468.468 0 0 1 .663 0l2.219 2.219 5.073-5.073a.474.474 0 0 1 .668 0 .468.468 0 0 1 0 .663Z",
    "data-name": "Caminho 786"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileCheck);
export default __webpack_public_path__ + "static/media/Icon-ProfileCheck.e2dc5b992e16d69bf388da417e427d86.svg";
export { ForwardRef as ReactComponent };